export interface FitAnalyticsEvent {
  productSerial: string;
  orderId: string;
  userId: string;
  purchasedSize: string;
  price: number;
  currency: string;
  shopCountry: string;
  language: string;
}

export interface FitAnalyticsDataLayerSummaryEvent {
  event: 'fa_data';
  fa_true: number;
  fa_false: number;
  fa_prods: string; // Concatenated product ids
  value: number;
}

function performTracking() {
  const scriptSrc = '//widget.fitanalytics.com/report_purchase.js';
  const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

  if (existingScript) {
    existingScript.parentNode?.removeChild(existingScript);
  } else {
    // Onload, the script actually performs the tracking requests
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.async = true;
    script.src = scriptSrc;

    head?.appendChild(script);
  }
}

export const trackFitAnalyticsEvents = (events: FitAnalyticsEvent[]) => {
  // Will be called once a certain fitanalytics script is loaded
  // by the tracking client.
  //
  // Adheres to http://developers.fitanalytics.com/documentation#purchases
  window._fitAnalyticsReportPurchase = () => {
    if (window._sendPurchaseInformation) {
      for (const event of events) {
        window._sendPurchaseInformation(event);
      }
    }
  };

  performTracking();
};
